import { useNavigate } from "react-router-dom";
import CardSection from "../design/CardSection";
import Logo from "../design/Logo";
import CardSectionNotOnClick from "../design/CardSectionNotOnClick";
import { SocketProps } from "../types/interface";
import { isMakeRoomShowAtom } from "../atoms/isMakeRoomShowAtom";
import { useRecoilState } from "recoil";
import MakeRoomSuccess from "../components/MakeRoomSuccessWord";

const SuccessedWords: React.FC<SocketProps> = ({ socket }) => {
  const navigate = useNavigate();
  const textArray = ["성", "공", "단", "어"];
  const [setMakeRoom, setMakeRoomShow] = useRecoilState(isMakeRoomShowAtom);
  const onHomeClick = () => {
    navigate("/fun_learning/home");
  };

  const onFunlearningAloneClick = () => {
    navigate("/fun_learning/funlearningalone");
  };

  const cardSectionData1 = {
    title: "학습방법",
    description: "단계별로 따라하세요!",
    emoji: "✅",
    listItems: [
      "첫번째! 성공한단어 학습하러가기 클릭하기",
      "두번째! 방 만들시 우측하단에 학습종류에서 성공한 단어 클릭하기",
      "세번째! 따로 단어 범위 설정하지 않아도 자동으로 성공한 단어 학습가능!",
    ],
  };

  const cardSectionDataCooperation = {
    title: "협력학습",
    description: "친구들과 경쟁하며 재밌게 학습해보세요!",
    emoji: "🏆",
    listItems: [
      "개인전과 팀전을 통한 학습!",
      "학습후 포인트를 통해 순위올리기!",
      "초등단어부터 고등단어까지!",
      "신나게 학습하다보면 단어가 머리속에!",
      "보카톡톡만의 동시 플레이 학습!",
    ],
    buttonText: "협력학습 시작하기",
    onClick: onHomeClick,
  };

  const showCreateRoom = () => {
    setMakeRoomShow(true);
  };

  return (
    <section className="bg-gray-200 dark:bg-gray-700">
      <div className="max-w-screen-xl px-4 py-8 mx-auto lg:py-24 lg:px-6">
        <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
          <h2 className="mb-4 text-3xl sm:text-5xl font-extrabold tracking-tight text-gray-900 dark:text-white">
            성공한 단어를 효과적으로 복습!
          </h2>

          <div className=" pt-10 font-bold text-gray-600 sm:text-xl dark:text-gray-400">
            준비가 되었다면?
          </div>
          <button
            onClick={showCreateRoom}
            className="mt-3 font-bold inline-block w-auto text-center min-w-[200px] px-6 py-4 text-white transition-all rounded-md shadow-xl sm:w-auto bg-gradient-to-r from-pink-600 to-pink-500 hover:bg-gradient-to-b dark:shadow-pink-900 shadow-pink-200 hover:shadow-2xl hover:shadow-pink-400 hover:-tranneutral-y-px "
          >
            성공한 단어 교실 만들기!
          </button>
        </div>
        <Logo textArray={textArray} />
        <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
          <h2 className="pt-10 mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
            성공한 단어 학습이란
          </h2>
          <p className="mb-5 text-gray-600 font-bold sm:text-xl dark:text-gray-400">
            보카톡톡만의 자체 알고리즘으로 성공한 단어를 효과적으로 복습!
          </p>
        </div>

        <CardSectionNotOnClick {...cardSectionData1} />

        <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
          <h2 className="pt-10 mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
            보카톡톡만의 성공한 단어 복습 프로그램!
          </h2>
          <p className="mb-5 text-gray-600 font-bold sm:text-xl dark:text-gray-400">
            보카톡톡만의 독자적 학습 알고리즘으로 성공한 단어도 효과적으로
            복습하세요!
          </p>
        </div>

        <div className="space-y-8 lg:grid lg:grid-cols-3 sm:gap-6 xl:gap-10 lg:space-y-0">
          {/* <CardSection {...cardSectionDataCooperation} />
           */}
        </div>
      </div>
      {setMakeRoom && (
        <div className=" fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="">
            <MakeRoomSuccess socket={socket} />
          </div>
        </div>
      )}
    </section>
  );
};

export default SuccessedWords;
